import React, {Dispatch, FC, useCallback, useEffect, useState} from 'react';
import {Alert, Button, Modal} from "react-bootstrap";
import {FaExpandAlt} from "react-icons/fa";
import ObjectService from "../../http/ObjectService";
import Loading from "../Loading";

interface PropsModal {
    visible: boolean;
    setVisible: Dispatch<boolean>;
    objectAnketaId: string;
    refreshTable: () => void;
}

const ObjectAnketaModalDelete: FC<PropsModal> = (props) => {
    const [objectAnketa, setObjectAnketa] = useState<any | null>(null);

    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [warning, setWarning] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [needsRefresh, setNeedsRefresh] = useState<boolean>(false);
    const [fullscreen, setFullscreen] = useState<boolean>(false);
    const [fio, setFio] = useState<string>("");

    // Обернул в useCallback, чтобы не было предупреждений в useEffect
    const fetchAnketa = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const { data } = await ObjectService.queryAnketa({
                options: {where: { id: props.objectAnketaId } }
            });

            if (data && data.length > 0) {
                const objectAnketaData = data[0];
                if (objectAnketaData.action === "DELETE") {
                    setError('Анкета объекта уже удалена');
                    setNeedsRefresh(true);
                }

                setFio(`${objectAnketaData.lastname} ${objectAnketaData.firstname} ${objectAnketaData.middlename}`);
                setObjectAnketa(objectAnketaData);
            } else {
                setNeedsRefresh(true);
                setError("Анкета не найдена");
            }
        } catch (err: any) {
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
        }
    }, [props.objectAnketaId]);

    useEffect(() => {
        if (props.visible) {
            void fetchAnketa();
        }
    }, [props.visible, fetchAnketa]);

    const handleObjectAnketaDelete = async () => {
        setLoading(true);
        try {
            const { data } = await ObjectService.deleteAnketa({
                values: { action: "DELETE" },
                options: { where: { id: objectAnketa.id } }
            });

            if (data) {
                setSuccess("Анкета объекта удалена");
                setWarning(null);
                setNeedsRefresh(true);
            } else {
                setWarning("Не удалось удалить анкету объекта");
            }
        } catch (err: any) {
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleHideModal = () => {
        if (needsRefresh) props.refreshTable();
        props.setVisible(false);
    };


    return (
        <Modal show={props.visible} size={"lg"} fullscreen={fullscreen ? true : "md-down"} scrollable={true}
               onHide={handleHideModal}>
            <div className="modal-header">
                <h5 className="mb-0">Удаление анкета объекта</h5>
                <div className={"d-flex gap-3"}>
                    <button type="button" className="btn-link" onClick={() => setFullscreen(!fullscreen)}>
                        <FaExpandAlt/>
                    </button>
                    <button type="button" className="btn-close" onClick={handleHideModal}></button>
                </div>
            </div>
            {loading
                ?
                <div style={{height: "200px"}}><Loading/></div>
                :
                <>
                    <Modal.Body>
                        {objectAnketa
                            ?
                            <>
                                {success && (
                                    <Alert variant={"success"}>
                                        <div><b>{objectAnketa.name}</b></div>
                                        {success}
                                    </Alert>
                                )}
                                {error && <Alert variant={"danger"}>{error}</Alert>}
                                {!needsRefresh && (
                                    <Alert variant={"warning"}>
                                        <div><b>{fio}</b></div>
                                        Анкета объекта будет удалена
                                    </Alert>
                                )}
                                {warning && <Alert variant={"warning"}>{warning}</Alert>}
                            </>
                            :
                            <Alert variant={"warning"}>Анкета объекта не найдена</Alert>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {objectAnketa && !needsRefresh && (
                            <Button variant="danger" type="button" onClick={handleObjectAnketaDelete}>Удалить</Button>)}
                        <Button variant="secondary" onClick={handleHideModal}>
                            {needsRefresh ? "Закрыть" : "Отмена"}
                        </Button>
                    </Modal.Footer>
                </>
            }
        </Modal>
    );
};

export default ObjectAnketaModalDelete;